<template> 
            <Data :data="data" v-if="!editing && !insert" :data2="data2" :data3="data3"></Data> 
</template>
<script> 
import Data from "./Components/Data.vue";

export default {
    components: {
        Data 
    },
    data() {
        return {
            data: {
                insuredPer: {
                    name: "Elvin Əxmədov Amin",
                    address: "Bakı şəh., Nərimanov ray., Əhməd Rəcəbli 45",
                    phone: "+994 55 123 45 67",
                    pin: "7PATGF1",
                    dob: "12.08.2000",
                    height: "176sm",
                    sex: "Kişi",
                    weight: "70kg",
                    mail: "ali.mammadov@example.com"
                },
                depNumber: "AZ76AZRT35090039440004920001-8.00",
                depRate: "12%",
                depRateClient: "10%",
                bankTax: "18%",
                riskSum: "250,000 AZN",
                sumInsured: "200,000 AZN",
                premium: "5,500 AZN",
                betaCost: "1,200 AZN",
                sumLimit: "300,000 AZN",
                holderPremium: "3,000 AZN",
                holderSumInsured: "150,000 AZN",
                coverDegree3: "75%",
                coverDegree2: "50%",
                beneficiary: {
                    name: "Kapital Bank ASC",
                    address: "Bakı şəh., Nizami küç. 67"
                }
            },
            data2: [
                {
                    check: true,
                    descr: "Siz tibbi müayinədən keçmisiniz (zəhmət olmasa tarixi qeyd edərdiniz)? Hər hansı kənarlaşmalar müəyyən edilibmi?"
                },
                {
                    descr: "Siz dərman preparatları qəbul edirsinizmi? Əgər cavab müsbətdirsə, dərmanın adını qeyd edərdiniz."
                },
                {
                    descr: "Siz pivə, çaxır və spirtli içkilər qəbul edirsinizmi? Əgər cavab müsbətdirsə, onda gün ərzində qəbul edilən içkilərin sayını göstərin."
                },
                {
                    check: true,
                    descr: "Sizin sənətiniz təhlükəli qiymətləndirilən əmək fəaliyyəti və ya məşğuliyyətlə (idman...) bağlıdırmı? Məsələn: aviasiya və ya avtomobil yarışları?"
                },
                {
                    check: false,
                    descr: "Sizin hər hansı xroniki xəstəliyiniz (diabet, ürək-damar, tənəffüs, mədə-bağırsaq və s.) varmı?"
                },
                {
                    check: false,
                    descr: "Siz son 5 il ərzində əməliyyat və ya hospitalizasiya olunmusunuzmu?"
                },
                {
                    check: false,
                    descr: "Sizdə allergiyalar (dərman, qida, toz, polen və s.) varmı?"
                },
                {
                    check: true,
                    descr: "Siz narkotik vasitələr qəbul etmisinizmi və ya hazırda qəbul edirsinizmi?"
                }
            ],
            data3: [
                {
                    check: true,
                    descr: "Ürəyin işemik xəstəliyi."
                },
                {
                    check: true,
                    descr: "Yüksək qan təzyiqi."
                },
                {
                    descr: "Şəkərli diabet."
                },
                {
                    descr: "Astma."
                },
                {
                    descr: "Qaraciyər xəstəlikləri (hepatit, sirroz)."
                },
                {
                    descr: "Beyin insultu və ya sinir sistemi xəstəlikləri."
                }
            ],
            loading: false,
            editing: false,
            insert: false
        }
    },
    methods: {
        GetData() {
            //None
        },
        ToggleEdit() {
            this.$emit('insert')
        },
        async Delete() {
            //None
        }
    },
    mounted() {
        if (this.$route.path.split("/")[3] == null) {
            this.insert = true
        }
        this.GetData()
    }
}
</script>